module.exports = __webpack_public_path__ + "static/img/ios_download.2928664.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Home/imgs/ios_download.svg
// module id = gHQ3
// module chunks = 0